/**
 * [PURE-INK 2026-10-15, user] "in the lead generator performance tab all the white colour will be in proper white in the dark
 * theme and in the light theme all the black will be in complete black, no blurry or light tone of the colour — same in the team
 * sameer report tab also". Wrap a page in <PureInk> and every neutral TEXT colour inside it is the pure one: #ffffff in the
 * dark theme, #000000 in the light theme. The app's own ink is a touch off (dark #fafafa, light #1a211e) and its secondary
 * text is a grey (dark #a0a0a0, light #5f6563); here all three text tokens — text, muted, dim — are one and the same.
 *
 * It is a nested theme, so it reaches everything drawn under the page, including what is drawn in a portal (the date and
 * dropdown popups, a modal): they are children of the page in React's tree and read the page's theme. Only the three text
 * tokens change — borders, backgrounds and the accent colours (greens, the reds, the blue / violet tags) are the app's own.
 * Anything outside the page (the top bar, the dock) is untouched.
 */
import React from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';

export const PURE_WHITE = '#ffffff';
export const PURE_BLACK = '#000000';

const pureInk = (outer?: DefaultTheme): DefaultTheme => {
  const base = outer as DefaultTheme; // always there: the app's ThemeProvider sits above every page
  const isDark = base.colorScheme === 'dark';
  const ink = isDark ? PURE_WHITE : PURE_BLACK;
  // [PURE-INK 2026-10-15, user] "make sure in both the themes the colour should look proper": what a contrast check (WCAG
  // 4.5 : 1) found under the light theme's softer greens — the table header labels take greenInk (4.7 : 1 on their grey pill,
  // green600 was 4.0 : 1) and the green buttons a deeper fill (white words 5 : 1+, were about 2.5 : 1). Dark is unchanged.
  return { ...base, text: ink, muted: ink, dim: ink, tableHeadInk: isDark ? '#4acd8b' : base.greenInk, primaryDeep: true };
};

const PureInk: React.FC<{ children?: React.ReactNode }> = ({ children }) => <ThemeProvider theme={pureInk}>{children}</ThemeProvider>;

export default PureInk;
